import React, { useState, useRef, useEffect } from 'react';
import './Menu.scss';
import { NavLink, useLocation } from 'react-router-dom';

export const Menunav = () => {
  const [activeSubmenu, setActiveSubmenu] = useState<string | null>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const role = localStorage.getItem('userRole') || '';
  const type = localStorage.getItem('userType');

  useEffect(() => {
    const calculateSidebarPosition = () => {
      if (sidebarRef.current) {
        const rect = sidebarRef.current.getBoundingClientRect();
        document.documentElement.style.setProperty('--sidebar-right', `${rect.right}px`);
        document.documentElement.style.setProperty('--sidebar-width', `${rect.width}px`);
      }
    };
    const handleClickOutside = (event: MouseEvent) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
        setActiveSubmenu(null);
      }
    };

    calculateSidebarPosition();
    const el = sidebarRef.current;
    const resizeObserver = typeof ResizeObserver !== 'undefined' && el ? new ResizeObserver(() => {
      calculateSidebarPosition();
    }) : null;
    if (resizeObserver && el) resizeObserver.observe(el);
    window.addEventListener('resize', calculateSidebarPosition);
    window.addEventListener('orientationchange', calculateSidebarPosition);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', calculateSidebarPosition);
      window.removeEventListener('orientationchange', calculateSidebarPosition);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuItemClick = (
    menuName: string,
    e?: React.MouseEvent<HTMLElement>,
  ) => {
    if (
      (menuName === 'product-mgmt' || menuName === 'laundry-mgmt') &&
      e &&
      e.currentTarget
    ) {
      const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
      document.documentElement.style.setProperty('--submenu-top', `${rect.top}px`);
      document.documentElement.style.setProperty('--sidebar-top', `${rect.top}px`);
    }

    setActiveSubmenu(activeSubmenu === menuName ? null : menuName);
  };

  const handleNavClick = () => {
    setActiveSubmenu(null);
  };

  const isMenuActive = (paths: string[]) => {
    return paths.some((path) => {
      const pathname = location.pathname;
      return pathname === path || pathname.startsWith(path + '/');
    });
  };

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? 'active' : '';

  const paymentFormField = [
    {
      accessorKey: 'paymentDate',
      header: 'Payment Date',
    },
    {
      accessorKey: 'invoiceNo',
      header: 'Invoice No',
    },
    {
      accessorKey: 'purchaseOrder',
      header: 'Purchase Order',
    },
    {
      accessorKey: 'paymentStatus',
      header: 'Payment Status',
    },
    {
      accessorKey: 'paymentType',
      header: 'Payment Type',
    },
    {
      accessorKey: 'transactionId',
      header: 'Transaction Id',
    },
    {
      accessorKey: 'paymentReferenceNo',
      header: 'Payment Reference No.',
    },
    {
      accessorKey: 'paymentAmount',
      header: 'Payment Amount',
    },
  ];

  return (
    <div className="side-bar" ref={sidebarRef}>
      {/* BUSINESS MANAGEMENT */}
      {['ADMIN_USER','CLIENT_ADMIN', 'ACCOUNTANT'].includes(role) && (
        <div
          className={`menu-item-group ${
            isMenuActive([
              '/business',
              '/business-store',
              '/business-department',
            ])
              ? 'active'
              : ''
          }`}
        >
          <div
            className="menu-item-title"
            onClick={(e) =>
              handleMenuItemClick('business-mgmt', e)
            }
          >
            Business Management
          </div>

          <div
            className={`submenu ${
              activeSubmenu === 'business-mgmt'
                ? 'show'
                : ''
            }`}
          >

            <NavLink
              to={'/business'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Business
              </div>
            </NavLink>

            <NavLink
              to={'/business-store'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Business Store
              </div>
            </NavLink>

            <NavLink
              to={'/business-department'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Business Department
              </div>
            </NavLink>
          </div>
        </div>
      )}

      {/* ORDER MANAGEMENT */}
      {[
        'ADMIN_USER',
        'CLIENT_ADMIN',
        'ACCOUNTANT',
        'DATA_ENTRY',
        'PRODUCTION',
        'CLIENTS',
      ].includes(role) && (
        <div
          className={`menu-item-group ${
            isMenuActive([
              '/business-store-order',
              '/business-verify',
              '/business-delivery-notes',
              '/garment-summary-note',
            ])
              ? 'active'
              : ''
          }`}
        >
          <div
            className="menu-item-title"
            onClick={(e) =>
              handleMenuItemClick('order-mgmt', e)
            }
          >
            Order Management
          </div>

          <div
            className={`submenu ${
              activeSubmenu === 'order-mgmt'
                ? 'show'
                : ''
            }`}
          >

            <NavLink
              to="/business-store-order"
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Business Orders
              </div>
            </NavLink>

            <NavLink
                  to="/business-verify"
                  className={navLinkClass}
                  onClick={handleNavClick}
                >
                  <div className="side-bar-content">
                    Verify Business Order
                  </div>
                </NavLink>

                <NavLink
                  to="/business-delivery-notes"
                  className={navLinkClass}
                  onClick={handleNavClick}
                >
                  <div className="side-bar-content">
                    Business Delivery Notes
                  </div>
                </NavLink>

                <NavLink
                  to="/garment-summary-note"
                  className={navLinkClass}
                  onClick={handleNavClick}
                >
                  <div className="side-bar-content">
                    Garment Summary Note
                  </div>
                </NavLink>
          </div>
        </div>
      )}

      {/* LABEL MANAGEMENT */}
      {[
        'ADMIN_USER',
        'CLIENT_ADMIN',
        'ACCOUNTANT',
        'PACK_USER',
        'PRODUCTION',
      ].includes(role) && (
        <div
          className={`menu-item-group ${
            isMenuActive([
              '/packaging-label',
              '/trolly-management',
              '/delivery-trolly',
              '/receive-trolly',
              '/garment-packaging-label',
              '/garment-delivery-trolly',
              '/trolly-inventory-report',
            ])
              ? 'active'
              : ''
          }`}
        >
          <div
            className="menu-item-title"
            onClick={(e) =>
              handleMenuItemClick('label-mgmt', e)
            }
          >
            Label Management
          </div>

          <div
            className={`submenu ${
              activeSubmenu === 'label-mgmt'
                ? 'show'
                : ''
            }`}
          >

            <NavLink
              to={'/packaging-label'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Linen Package Label
              </div>
            </NavLink>

            <NavLink
              to={'/trolly-management'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Trolly Management
              </div>
            </NavLink>

            <NavLink
              to={'/delivery-trolly'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Linen Delivery Note
              </div>
            </NavLink>
            <NavLink
              to={'/receive-trolly'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Receive Trolly
              </div>
            </NavLink>
            <NavLink
              to={'/garment-packaging-label'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Garment Packaging Label
              </div>
            </NavLink>
            <NavLink
              to={'/garment-delivery-trolly'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Garment Delivery Note
              </div>
            </NavLink>
            <NavLink
              to={'/trolly-inventory-report'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Trolly Inventory Report
              </div>
            </NavLink>
          </div>
        </div>
      )}

      {/* LAUNDRY PROCESS MANAGEMENT */}
      {['ADMIN_USER','CLIENT_ADMIN', 'ACCOUNTANT', 'PRODUCTION'].includes(
        role,
      ) && (
        <div
          className={`menu-item-group ${
            isMenuActive(['/washingLoad', '/washingReport'])
              ? 'active'
              : ''
          }`}
        >
          <div
            className="menu-item-title"
            onClick={(e) => handleMenuItemClick('laundry-mgmt', e)}
          >
            Laundry Process Management
          </div>
          <div
            className={`submenu ${
              activeSubmenu === 'laundry-mgmt' ? 'show' : ''
            }`}
            data-group="laundry-mgmt"
          >
            <NavLink
              to={'/washingLoad'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Washing Load
              </div>
            </NavLink>
            <NavLink
              to={'/washingReport'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Washing Report
              </div>
            </NavLink>
          </div>
        </div>
      )}

      {/* PRODUCT MANAGEMENT */}
      {['ADMIN_USER','CLIENT_ADMIN', 'ACCOUNTANT'].includes(role) && (
        <div
          className={`menu-item-group ${
            isMenuActive(['/product-master', '/price-master'])
              ? 'active'
              : ''
          }`}
        >
          <div
            className="menu-item-title"
            onClick={(e) => handleMenuItemClick('product-mgmt', e)}
          >
            Product Management
          </div>
          <div
            className={`submenu ${
              activeSubmenu === 'product-mgmt' ? 'show' : ''
            }`}
            data-group="product-mgmt"
          >
            <NavLink
              to={'/product-master'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Product Master
              </div>
            </NavLink>
            <NavLink
              to={'/price-master'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Price Master
              </div>
            </NavLink>
          </div>
        </div>
      )}

      {/* RETAIL LINKS */}
      {type === 'Retail' ? (
        <>
          <NavLink
            to={'/retail-store-order'}
            className={navLinkClass}
            onClick={handleNavClick}
          >
            <div className="side-bar-content">Retail Orders</div>
          </NavLink>
          <NavLink
            to={'/retail-invoices'}
            className={navLinkClass}
            onClick={handleNavClick}
          >
            <div className="side-bar-content">Retail Store Invoices</div>
          </NavLink>
          <NavLink
            to={'/retail-payments'}
            className={navLinkClass}
            onClick={handleNavClick}
            state={{ paymentFormField: paymentFormField }}
          >
            <div className="side-bar-content">Retail Payments</div>
          </NavLink>
        </>
      ) : null}

      {/* CUSTOMER LINKS */}
      {type === 'Customer' ? (
        <>
          <NavLink
            to={'/customer'}
            className={navLinkClass}
            onClick={handleNavClick}
          >
            <div className="side-bar-content">Customer</div>
          </NavLink>
          <NavLink
            to={'/customer-order'}
            className={navLinkClass}
            onClick={handleNavClick}
          >
            <div className="side-bar-content">Customer Orders</div>
          </NavLink>
          <NavLink
            to={'/customer-invoices'}
            className={navLinkClass}
            onClick={handleNavClick}
          >
            <div className="side-bar-content">Customer Invoices</div>
          </NavLink>
          <NavLink
            to={'/customer-payments'}
            className={navLinkClass}
            onClick={handleNavClick}
            state={{ paymentFormField: paymentFormField }}
          >
            <div className="side-bar-content">Customer Payments</div>
          </NavLink>
        </>
      ) : null}

      {/* ADMINISTRATION */}
      {['ADMIN_USER','CLIENT_ADMIN', 'ACCOUNTANT'].includes(role) && (
        <div
          className={`menu-item-group ${
            isMenuActive([
              '/cost-center',
              '/processing-center',
              '/category',
              '/department',
              '/mediafile',
              '/user',
              '/business-user',
            ])
              ? 'active'
              : ''
          }`}
        >
          <div
            className="menu-item-title"
            onClick={(e) => handleMenuItemClick('admin-mgmt', e)}
          >
            Administration
          </div>
          <div
            className={`submenu ${
              activeSubmenu === 'admin-mgmt' ? 'show' : ''
            }`}
          >
            <NavLink
              to={'/cost-center'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">Cost Center</div>
            </NavLink>
            <NavLink
              to={'/processing-center'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">Processing Center</div>
            </NavLink>
            <NavLink
              to={'/category'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">Category</div>
            </NavLink>
            <NavLink
              to={'/department'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">Department</div>
            </NavLink>
            <NavLink
              to={'/mediafile'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">Media Items</div>
            </NavLink>
            {['ADMIN_USER', 'CLIENT_ADMIN'].includes(role) && (
              <NavLink
                to={'/user'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">User Management</div>
              </NavLink>
            )}
            {['ADMIN_USER', 'CLIENT_ADMIN'].includes(role) && (
              <NavLink
                to={'/business-user'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  Business User Management
                </div>
              </NavLink>
            )}
          </div>
        </div>
      )}

      {/* REPORTS */}
      {[
        'ADMIN_USER',
        'CLIENT_ADMIN',
        'ACCOUNTANT',
        'PRODUCTION',
        'CLIENTS',
      ].includes(role) && (
        <div
          className={`menu-item-group ${
            isMenuActive([
              '/inhouse',
              '/inhouse-batch',
              '/businesssales',
              '/business-batch',
              '/dailyRevenue',
              '/dailyCustomerRevenue',
              '/openOrderReport',
            ])
              ? 'active'
              : ''
          }`}
        >
          <div
            className="menu-item-title"
            onClick={(e) => handleMenuItemClick('reports-mgmt', e)}
          >
            Reports
          </div>
          <div
            className={`submenu ${
              activeSubmenu === 'reports-mgmt' ? 'show' : ''
            }`}
          >
            {/* {role !== 'PRODUCTION' && (
              <NavLink
                to={'/inhouse'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  InHouse Sale Summary Report
                </div>
              </NavLink>
            )} */}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink
                to={'/inhouse-batch'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  InHouse Batch Summary Report
                </div>
              </NavLink>
            )}
            {/* {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink
                to={'/businesssales'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  Business Sales Summary Report
                </div>
              </NavLink>
            )} */}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink
                to={'/business-batch'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  Business Batch Summary Report
                </div>
              </NavLink>
            )}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink
                to={'/dailyRevenue'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  Daily Revenue Report
                </div>
              </NavLink>
            )}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink
                to={'/dailyCustomerRevenue'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  Daily Customer Revenue Report
                </div>
              </NavLink>
            )}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink
                to={'/revenueByKiloReport'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  Revenue by Kilo Report
                </div>
              </NavLink>
            )}
            {role !== 'CLIENTS' && (
              <NavLink
                to={'/openOrderReport'}
                className={navLinkClass}
                onClick={handleNavClick}
              >
                <div className="side-bar-content">
                  Open Order Report
                </div>
              </NavLink>
            )}
            <NavLink
              to={'/customerSaleSummary'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Customer Sale Summary Report
              </div>
            </NavLink>
            <NavLink
              to={'/customerRewashSummary'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Customer Rewash Summary Report
              </div>
            </NavLink>
            <NavLink
              to={'/customerKiloQtyRevenue'}
              className={navLinkClass}
              onClick={handleNavClick}
            >
              <div className="side-bar-content">
                Customer Kilo Qty Revenue Report
              </div>
            </NavLink>
          </div>
        </div>
      )}
    </div>
  );
};